import _ from "lodash";
import {
  Component,
} from "react";
import store from "CommonState/store";
import {
  createInjectsSelector,
  injectsFromSchema,
} from "CommonCore/schema-util";
import SHKFormTab from "App/shk-form-tab";
import {
  istArtTarifvertrag,
  istTypWerkvertrag,
  ROLLEN,
  VERTRAGSARTEN_LEHRAUFTRAG,
  VERTRAGSARTEN_VORTRAG,
} from "App/constants";

import {
  subpanels as subpanels_stamm,
} from "App/person-stamm-tab";
import {
  subpanels as subpanels_studien,
} from "App/person-studien-tab";
import {
  subpanels as subpanels_lbvperson,
} from "App/person-lbvperson-tab";
import {
  subpanels as subpanels_lbvstatus,
} from "App/person-lbvstatus-tab";

const panels = _.cloneDeep([...subpanels_stamm, ...subpanels_studien, ...subpanels_lbvperson, ...subpanels_lbvstatus]);

const injects = _.flatMap(panels, s => injectsFromSchema(s.schema));
const selectInjects = createInjectsSelector(injects);

@store(...injects, "user")
export default class PersonKomplettTab extends Component {
  constructor() {
    super();
  }
  render() {
    const { user, antrag } = this.props;

    const istWerkvertrag = istTypWerkvertrag(antrag.a_katid);
    const istLehrauftrag = antrag.a_artid == VERTRAGSARTEN_LEHRAUFTRAG;
    const istTarifvertrag = istArtTarifvertrag(antrag.a_artid);
    const istVortrag = VERTRAGSARTEN_VORTRAG.indexOf(antrag.a_artid) >= 0;

    let mypanels = _.cloneDeep(panels);

    if (istWerkvertrag) {
      // Werkvertrag-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "buwbv", "adresse", "bank", "werkvertrag"].indexOf(x.key) >= 0);
    } else if (istLehrauftrag) {
      // Lehrauftrag-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "adresse", "bank", "werdegang"].indexOf(x.key) >= 0);
    } else if (istVortrag) {
      // Vortrag/Kolloquium-Panels erlauben
      mypanels = mypanels.filter(x => ["stamm", "adresse", "bank"].indexOf(x.key) >= 0);
    } else if (istTarifvertrag) {
      // Alles außer buwbv, werkvertrag, studium erlauben
      mypanels = mypanels.filter(x => ["buwbv", "werkvertrag", "studienbereich"].indexOf(x.key) < 0);
    } else {
      // Alles außer buwbv erlauben
      mypanels = mypanels.filter(x => ["buwbv", "werkvertrag"].indexOf(x.key) < 0);
    }

    if (user && user.ro_id == ROLLEN.ROLLE_ANTRAGSTELLER) {
      // Bei den Antragstellern die SVA-Nummer ausblenden
      const personPanel = panels.find(p => p.key == "stamm");
      personPanel.schema.table = _.filter(personPanel.schema.table, f => f.field != "p_svakey");
    }

    return <SHKFormTab subpanels={mypanels} injects={selectInjects(this.props)} />;
  }
}
